import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { customFetchBase, defautBaseQuery, defauttestBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString } from '../../utils/API/requestMiddleware';

const fileAPI = createApi({
    baseQuery: defauttestBaseQuery, // Replace with your API endpoint
    reducerPath: 'fileAPI',
    endpoints: (builder) => ({
        getFile: builder.query({
            query: (data) => ({
                url: `?FileName=${data.fileName}&ModuleType=${data.moduleType}`,
                method: 'GET',
                responseHandler: (response) => response.blob()
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const { useLazyGetFileQuery } = fileAPI;
export default fileAPI;


